import { seoFragment } from './fragments.gql'

export default slug => `query {
  sidebarPage(filter: {slug: {eq: "${slug.replace('/', '__')}"}}) {
    title
    body
    updatedAt
    slug
    ${seoFragment}
  }
}`
